import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-floorplan-package',
    templateUrl: './floorplan-package.component.html',
    styleUrls: ['./floorplan-package.component.scss']
})

export class FloorplanPackageComponent implements OnInit {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<any>) {
    }

    ngOnInit(): void {
    }
}
